import React from "react"

import NoExist from "@irati/ui/src/Layout/NoExist"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"

const DealsNothingToSeeHere = () => {
  return (
    <NoExist><FormattedMessage id="perks.components.dealList.nothingToSeeHere.body" /></NoExist>
  )
}

export default injectIntl(DealsNothingToSeeHere)
